import { useNavigate } from 'react-router-dom';
import LogoDecatron from '../../assets/icons/decatron_white_logo.png';
import Button from '../../components/Button/Button';
import InputForm from '../../components/InputForm/InputForm';
import { LoginSchema } from '../../data/validations/loginSchema';
import { useForms } from '../../hooks/useForms';
import styles from './Login.module.scss';
import { AxiosHttp } from '../../services/axiosService';
import { notify } from '../../services/toastService';

interface ILoginResponse {
    redirect_url: string;
}

interface IResponse<T> {
    statusCode: number;
    body: T;
    message: string;
}

export default function Login() {
    const { formData, handleFormChange, validFields } = useForms(LoginSchema, {
        email: '',
    });

    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const loginRequest = new AxiosHttp('http://localhost:5003');

            const response = await loginRequest.post<IResponse<ILoginResponse>>('/login', formData);

            console.log(response);

            void navigate('/marketplace');
        } catch (err) {
            notify.error(`Impossível Buscar Notícias: ${String(err)}`);
        }
    };

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginCard}>
                <img src={LogoDecatron} alt="Logo Decatron" />
                <h2>Acesse Nosso Marketplace!</h2>

                <InputForm
                    inputName="email"
                    label="E-mail"
                    onChangeInput={handleFormChange}
                    placeholder="Digite seu Email"
                    isValidField={validFields.email}
                    value={formData.email}
                    customStyles={styles.customStylesLogin}
                />
                <Button
                    text="Prosseguir"
                    onClickButton={() => void handleLogin()}
                    customClass={styles.customStylesBtn}
                />
            </div>
        </div>
    );
}
